<div class="page-content">
  <div class="row">
    <div class="col-12 progress-top-level centered">
      <!--
      dashboard title is from
      -->
      <h1 class="header-1-recon" translate>OMBUDSMAN.TITLE</h1>
      <p class="divider d-none d-md-block"></p>
    </div>
  </div>
  <!-- Start Reconsideration Request page  -->
  <div class="container">
    <div class="row">
      <div class="col-12">
        <!-- Form Start -->
        <form #reconsiderationNewform="ngForm">
          <div class="row">
            <div class="content-panel with-side-bar col-12">
              <div class="main">
                <div id="myAlertBannerRecID" [ngClass]="{'myAlertBannerEmptyRec' : bannerStatus === 'empty','myAlertBannerRec1' : bannerStatus === 'success','myAlertBannerRec2' : bannerStatus === 'failure'}">
                  <!-- banner start -->
                  @if (bannerStatus) {
                    <div class="row" class="dashboard-alert col-12 col-lg-9 alert alert-dismissible" [ngClass]="{'alert-success':  bannerStatus === 'success', 'alert-danger' : bannerStatus === 'failure'} ">
                      <a href="#" tabindex="0" (click)="onClick()" class="close alert-close" data-bs-dismiss="alert" aria-label="close">×</a>
                      @if (bannerStatus === 'success') {
                        <span class="far" [ngClass]="{'fa-check-circle' : bannerStatus === 'success', 'fa-minus-square' : false}"
                        aria-hidden="true"></span>
                      }
                      <div class="alert-content">
                        <span [innerHTML]="bannerMessage | translate"></span>
                        <br>
                        </div>
                      </div>
                    }
                  </div>

                  <!-- end banner -->
                  <div class="middle req-title" id="requestTitle">
                    <p class="req-title-p1" translate>OMBUDSMAN.REQUEST_INFO</p>

                    <p class="required req-title-p2" translate>GENERAL_REUSABLE.REQUIRED_FIELD</p>
                  </div>
                  <div class="req-clear-div"></div>

                  <table class="table-border">
                    <tr>
                      <td>
                        <div class="middle">
                          <b>
                            <span translate>OMBUDSMAN.REQUESTER_NAME</span>: </b>
                          </div>
                        </td>
                        <td class="table-width">
                          &nbsp;
                        </td>
                        <td>
                          <span id="userNameId"> {{user.name}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="middle">
                            <b>
                              <span translate>OMBUDSMAN.REQUESTER_DOB</span>: </b>
                            </div>
                          </td>
                          <td class="table-width">
                            &nbsp;
                          </td>
                          <td>
                            <span id="dateOfBirthId">{{dobFormatStr}}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="middle">
                              <b>
                                <span translate>OMBUDSMAN.REQUESTER_PROGRAM</span>: </b>
                              </div>
                            </td>
                            <td class="table-width">
                              &nbsp;
                            </td>
                            <td>
                              <span id="programId">{{programName}}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="middle">
                                <b>
                                  <span translate>OMBUDSMAN.REQUESTER_MEMBERSHIP_ID</span>: </b>
                                </div>
                              </td>
                              <td class="table-width">
                                &nbsp;
                              </td>
                              <td>
                                <span id="membershipId">{{user.membershipOrPassId}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div class="middle">
                                  <b>
                                    <span translate>OMBUDSMAN.REQUESTER_EMAIL</span>: </b>
                                  </div>
                                </td>
                                <td class="table-width">
                                  &nbsp;
                                </td>
                                <td>
                                  <span id="emailId">{{user.email}}</span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="middle">
                                    <b><span translate>APPLICATION.PERSONAL_INFO.EMAIL_OPT_OUT</span></b>
                                  </div>
                                </td>
                                <td class="table-width">
                                  &nbsp;
                                </td>
                                <td>
                                  @if (emailOptoutInd) {
                                    <i  class="fa-solid fa-check"></i>
                                  }
                                  @if (!emailOptoutInd) {
                                    <i class="fa-regular fa-square"></i>
                                  }
                                </td>
                              </tr>
                            </table>
                            <div class="middle">
                              <br>
                              </div>

                              <div class="middle">

                                @if (isDeniedRevokedOrClosed()) {
                                  <div class="middle div-middle-color">
                                    <span [innerHTML]="'OMBUDSMAN.REVIEW_BY_THE_OMBUDSMAN_NOTE' | translate"></span>
                                  </div>
                                }
                                <br>
                                  <span class="required">*</span>
                                  <b>
                                    <span translate>OMBUDSMAN.REQUESTER_EXPLAIN</span>
                                  </b>
                                </div>
                                <div class="middle">
                                  <textarea [value-type]="'textPattern'" rows="4" tabindex="0" class="form-control" [maxlength]="textAreaMaxLength" id="reconsiderationExplanationData" name="reconsiderationExplanationData"
                                  [(ngModel)]="reconsiderationExplanationData" trimSpace #recExplain (keyup)="onKeyUp($event, recExplain.value)" (focusout)="onFocusOut(recExplain.value)"></textarea>
                                </div>

                <div class="middle">
                  <small>{{remainingCharactersCount}}</small><small class="char-count-ml" translate>OMBUDSMAN.REMAINING_NUMBER_OF_CHARACTERS</small>
                </div>

                                @if (hasExplanationMinEnteredError) {
                                  <div class="field-error">
                                    <p translate>OMBUDSMAN.EXPLANATION_MIN_MSG</p>
                                  </div>
                                }

                                @if (hasExplanationError) {
                                  <div class="field-error">
                                    <p translate>OMBUDSMAN.EXPLANATION_MISSING</p>
                                  </div>
                                }

                                <div class="middle">
                                  <br>
                                  </div>

                                  <div class="middle">
                                    <b>
                                      <span translate>OMBUDSMAN.ADD_ATTACHMENTS</span>
                                    </b>
                                    <tooltip [tooltip-text]="'OMBUDSMAN.ATTACHMENTS_TOOLTIP'"></tooltip>
                                    <br>
                                      <span [innerHTML]="'OMBUDSMAN.ATTACH_DOCUMENTS_OR_DRAG_AND_DROP' | translate"></span>
                                    </div>
                                    <div class="middle">
                                      <br>
                                      </div>
                                      <!-- file upload start  -->
                                      @if (!isSelectedFilesValid) {
                                        <div class="field-error">
                                          @for (errMsg of invalidFileErrors; track errMsg) {
                                            <p>{{errMsg}}</p>
                                          }
                                        </div>
                                      }

                                      <div class="middle">

                                        <div class="row row-button-group">
                                          <div class="col-12 col-md-4 col-lg-2">
                                            <div class="upload-btn-wrapper">
                                              <button id="multiSelectButtonId" id="attachHov" class="btn btn--attach multi-select-butt1" translate>OMBUDSMAN.ATTACH_FILES</button>
                                              <input data-bs-toggle="tooltip" data-bs-placement="top" title="{{'OMBUDSMAN.ATTACH_UP_TO_TEN_FILES' | translate}}" id="multiFileInputId"
                                                class="attach-input" name="omSelectmultifile" type="file" ng2FileSelect [uploader]="uploader"
                                                accept=".pdf,.jpg,.gif,.png,.docx,.doc" multiple (onFileSelected)="onFileSelected($event)"
                                                />

                                            </div>
                                          </div>
                                          <div class="col-12 col-md-4 offset-md-4 col-lg-3 offset-lg-1">
                                            <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)" [uploader]="uploader"
                                              (onFileDrop)="onFileSelected($event)" data-bs-toggle="tooltip" data-bs-placement="top" title="{{'OMBUDSMAN.ATTACH_UP_TO_TEN_FILES' | translate}}" class="my-drop-zone file-drop-c" translate>
                                              OMBUDSMAN.DRAG_AND_DROP_FILES
                                            </div>
                                          </div>

                                        </div>

                                      </div>


                                      <div class="row">
                                        <div class="col-lg-9 req-div-margin">
                                          <p></p>
                                          @if (uploader.queue.length>0) {
                                            <div class="middle">
                                              <!-- Start Only show table if files are selected-->
                                              <b>
                                                <span translate>OMBUDSMAN.ATTACHED_FILES</span>
                                              </b>
                                              <div class="tab-content" style="padding-left: 0 !important;">
                                                <div id="dataTable" class="panel-body table-responsive" style="padding-left: 0 !important;">
                                                  <table role="grid" class="table table-sortable table-striped mdl-js-data-table">
                                                    <thead class="att-tab-bac-col">
                                                      <tr role="row">
                                                        <th scope="col" role="columnheader" class="table-headerl non-numeric sortable" (click)="sortColumnRecon('fileName', sortDirection)" (keydown)="sortColumnRecon('fileName', sortDirection)" aria-sort="none" tabindex="0" data-sort="text" translate>OMBUDSMAN.FILE_NAME
                                                          <div class="float-end">
                                                            @if (sortField=='fileName' && sortDirection=='asc') {
                                                              <i class="fa fa-caret-up"></i>
                                                            }
                                                            @if (sortField=='fileName' && sortDirection=='desc') {
                                                              <i class="fa fa-caret-down"></i>
                                                            }
                                                          </div>
                                                        </th>
                                                        <th scope="col" role="columnheader" class="table-headerc non-numeric sortable" (click)="sortColumnRecon('fileSize', sortDirection)" (keydown)="sortColumnRecon('fileSize', sortDirection)" aria-sort="none" tabindex="0" translate>OMBUDSMAN.FILE_SIZE
                                                          <div class="float-end">
                                                            @if (sortField=='fileSize' && sortDirection=='asc') {
                                                              <i class="fa fa-caret-up"></i>
                                                            }
                                                            @if (sortField=='fileSize' && sortDirection=='desc') {
                                                              <i class="fa fa-caret-down"></i>
                                                            }
                                                          </div>
                                                        </th>
                                                        <th scope="col" role="columnheader" class="table-headerc non-numeric" tabindex="0"><span translate>OMBUDSMAN.DATE_TIME</span></th>
                                                        <th scope="col" role="columnheader" class="table-headerc non-numeric" tabindex="0"><span translate>OMBUDSMAN.ACTIONS</span></th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      @for (item of uploader.queue; track item) {
                                                        <tr class="stripe-row" >
                                                          <td>{{ item?.file?.name }}</td>
                                                          <td scope="row" class="non-numeric">{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                                                          <td class="non-numeric">{{ fileAddedDate | ttpDate:'MM/DD/YYYY hh:mm a' }}</td>
                                                          <td class="non-numeric" nowrap>
                                                            <button data-bs-toggle="tooltip" data-bs-placement="top" title="{{'OMBUDSMAN.REMOVE_THIS_ATTACHMENT' | translate}}" type="button"
                                                              class="btn-file-action btn-danger btn-xs att-fil-btn" (click)="removeSelectedFile(item);">
                                                              <span class="fas fa-trash-alt"></span>
                                                              <span class="req-remove" translate>OMBUDSMAN.RECON_REMOVE</span>
                                                            </button>
                                                          </td>
                                                        </tr>
                                                      }
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          }
                                          <!-- End -- Only show table if files are selected-->
                                          @if (uploader.queue.length == 0) {
                                            <div class="middle">
                                              <b>
                                                <span translate>OMBUDSMAN.ATTACHED_FILES</span>
                                              </b>
                                              <div class="tab-content" style="padding-left: 0 !important;">
                                                <div id="dataTable" class="panel-body table-responsive" style="padding-left: 0 !important;">
                                                  <table class="table table-sortable table-striped mdl-js-data-table">
                                                    <thead class="att-tab-bac-col">
                                                      <tr>
                                                        <th scope="col" class="table-headerl non-numeric" tabindex="0"><span translate>OMBUDSMAN.FILE_NAME</span></th>
                                                        <th scope="col" class="table-headerl non-numeric" tabindex="0"><span translate>OMBUDSMAN.FILE_SIZE</span></th>
                                                        <th scope="col" class="table-headerl non-numeric" tabindex="0"><span translate>OMBUDSMAN.DATE_TIME</span></th>
                                                        <th scope="col" class="table-headerl non-numeric" tabindex="0"><span translate>OMBUDSMAN.ACTIONS</span></th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      <tr class="stripe-row">
                                                        <td colspan="4" scope="row" class="non-numeric"><span translate>OMBUDSMAN.RECON_ATTACHMENTS</span></td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          }
                                          <!-- End -- Only show table if files are selected-->
                                        </div>
                                      </div>

                                      @if (uploader.queue.length==10000000) {
                                        <div class="middle">
                                          <div class="row">
                                          </div>
                                        </div>
                                      }
                                      <!-- End -- No files are selected-->
                                      <!-- file upload End  -->
                                    </div>

                                    <!--outside of container buttons-->
                                    <div class="middle">

                                      <div class="row row-button-group justify-content-between flex-md-row flex-column-reverse">
                                        <!-- debug dash button function added for banners -->
                                        <div class="col-12 col-md-3">
                                          <button class="btn--cancel d-block w-100 req-btn-color" id="cancelHov" data-bs-toggle="tooltip" data-bs-placement="top" title="{{'OMBUDSMAN.CANCEL_YOUR_RECONSIDERATION_REQUEST' | translate}}"
                                          (click)="showCancelModal()" translate>OMBUDSMAN.REQUESTER_ATTACHMENT_CANCEL</button>
                                        </div>
                                        <div class="col-12 col-md-3">
                                          <button class="btn--submit d-block w-100 btn-primary" id="submitHov" data-bs-toggle="tooltip" data-bs-placement="top" title="{{'OMBUDSMAN.SUBMIT_YOUR_RECONSIDERATION_REQUEST' | translate}}"
                                            [disabled]="!isFormSubmitable" (click)="showSaveModal()" translate [style.background-color]="isFormSubmitable ? '#00568F' : '#999999'">OMBUDSMAN.REQUESTER_ATTACHMENT_SUBMIT
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                              <!-- From End-->
                              <!--
                              https://github.com/valor-software/ng2-file-upload
                              https://github.com/valor-software/ng2-file-upload/tree/master/demo/components/file-upload
                              https://valor-software.com/ng2-file-upload/
                              https://developer.mozilla.org/en-US/docs/Web/API/File/Using_files_from_web_applications
                              https://codepen.io/adambene/pen/xRWrXN
                              https://stackblitz.com/edit/ng2-file-upload?file=app%2Fapp.component.html
                              -->



                            </div>
                          </div>
                        </div>
                        <!-- End Reconsideration Request page  -->
                      </div>
